import { Injectable, signal } from '@angular/core';

export interface PropertyIntakePrefillAddress {
  streetAddress?: string;
  unit?: string;
  city?: string;
  state?: string;
  county?: string;
  zipCode?: string;
  latitude?: number | null;
  longitude?: number | null;
}

@Injectable({ providedIn: 'root' })
export class PropertyIntakeModalService {
  readonly visible = signal(false);

  readonly prefillAddress = signal<PropertyIntakePrefillAddress | null>(null);

  // Bumped whenever the intake form is closed/reset (X button, or finishing the
  // success flow) — the landing page's address autocomplete watches this to clear
  // the address it prefilled the form with, so a re-opened form starts blank.
  readonly addressCleared = signal(0);

  open(prefillAddress?: PropertyIntakePrefillAddress): void {
    if (prefillAddress) {
      this.prefillAddress.set(prefillAddress);
    }
    this.visible.set(true);
  }

  close(): void { this.visible.set(false); }

  notifyAddressCleared(): void { this.addressCleared.update(count => count + 1); }
}
